export const formatPhoneNumber = (value) => {
   if (!value) {
      return value
   }
   const onlyNums = value.toString().replace(/[^\d]/g, '');
   const onlyNumsLength = onlyNums.length;

   if (onlyNumsLength <= 3) {
      return onlyNums;
   } else if (onlyNumsLength <= 7) {
      return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
   } else if (onlyNumsLength <= 10) {
      return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(
         6,
         10
      )}`
   } else {
      return `${onlyNums.slice(0, 1)}-${onlyNums.slice(1, 4)}-${onlyNums.slice(4, 7)}-${onlyNums.slice(7, 11)}`
   }
};

export const formatCompensationNumber = (value) => {
   if (!value) {
      return value
   }
   return `$${value.toString().split(/(?=(?:\d{3})+(?:\.|$))/g).join(",")}`;
};


/*
      <(^_^)> Bryan Perez

      INPUT    string of ONLY int
      OUTPUT   converts int to string currency format with decimal place to the tenth place
               removes tailing zero in front

      EXAMPLE:
         INPUT    "1234"
         OUTPUT   "12.34"
 */
export const intStringToCurrencyString = (intStr) => {
   if (!intStr) {
      return "";
   } else {
      let formattedStr = parseInt(intStr).toString();
      while (formattedStr.length < 3) {
         formattedStr = `0${formattedStr}`;
      }
      return `${formattedStr.substring(0, formattedStr.length -2)}.${formattedStr.substring(formattedStr.length-2)}`
   }
};


/*

      <(^_^)> Bryan Perez

      EXTENDS intStringToCurrencyString

      INPUT    string of ONLY int
      OUTPUT   converts int to string currency format with decimal place to the tenth place
               with proper comma placements

      EXAMPLE:
         INPUT    "1234"
         OUTPUT   "$12.34"

      EXAMPLE:
         INPUT    ""
         OUTPUT   ""
 */
export const intStringToCurrencyDisplay = (intStr) => {
   const currencyStr = intStringToCurrencyString(intStr);
   const [wholeNum, decimal] = currencyStr.split(".");
   if (!currencyStr) {
      return ""
   } else if (wholeNum.length < 3) {
      return `$${currencyStr}`;
   } else {
      let formattedWholeNum = `${wholeNum.slice(wholeNum.length - 3)}`;
      for (let end = wholeNum.length - 3; end > 0; end -= 3) {
         const start = Math.max(end - 3,  0);
         const valToAppend = wholeNum.slice(start, end);

         formattedWholeNum = `${valToAppend},${formattedWholeNum}`
      }
      return `$${formattedWholeNum}.${decimal}`;
   }
};